import { Navigate } from "react-router-dom";
import { useAuth, hasRole, hasModule } from "@/lib/auth";

/**
 * Two ways to gate a route:
 *  1. `module="invoices"` — checks the user's per-user module permissions.
 *     This is the preferred approach ("manual list wins").
 *  2. `roles={["admin","sales"]}` — legacy role-based check, kept for
 *     backwards compatibility with un-migrated routes.
 * When both are provided, BOTH must pass.
 */
export default function ProtectedRoute({ children, roles, module }) {
  const { user, booting } = useAuth();
  if (booting) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && roles.length > 0 && !hasRole(user, ...roles)) {
    return <Navigate to="/" replace />;
  }
  if (module && !hasModule(user, module)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
